<svg [style.width.px]="size()" [style.height.px]="size()" class="animate-spinner-rotate relative"
    viewBox="25 25 50 50">
    <circle [ngClass]="color() === 'default' ? 'stroke-blue-fade': 'stroke-transparent'" cx="50" cy="50" r="21" fill="none" stroke-miterlimit="10" stroke-width="7"
        stroke-linecap="round"></circle>
    <circle [ngClass]="{
        'stroke-blue': color() === 'default',
        'stroke-primary-foreground': color() === 'primary',
        'stroke-success-foreground': color() === 'success',
        'stroke-secondary-foreground': color() === 'secondary',
        'stroke-destructive-foreground': color() === 'destructive',
        'stroke-warning-foreground': color() === 'warning',
        'stroke-danger-foreground': color() === 'danger',
        'stroke-blue-foreground': color() === 'info',
        'stroke-purple-foreground': color() === 'purple',
        'stroke-pink-foreground': color() === 'pink',
        'stroke-orange-foreground': color() === 'orange',
        'stroke-lime-foreground': color() === 'lime',
        'stroke-emerald-foreground': color() === 'emerald',
        'stroke-cyan-foreground': color() === 'cyan',
        'stroke-foreground': color() === 'ghost' || color() === 'ghost-active' || color() === 'outline',
        'stroke-link': color() === 'link',
        'stroke-muted-foreground': color() === 'ghost-inactive',
        'stroke-ring': color() === 'ring'
    }"
     class="animate-spinner-dash" cx="50" cy="50" r="21" fill="none" stroke-miterlimit="10"
        stroke-width="7" stroke-linecap="round"></circle>
</svg>